<template>
    <b-modal
        :title="uLang('app.overview_trajectory_enrolments')"
        :ok-only="true"
        :ok-title="uLang('app.close')"
        ref="modal"
        @hidden="$emit('hidden')"
        class="relative"
        :visible="value"
        @input="$emit('input', $event.target.value)"
    >
        <div class="row">
            <div class="col-12 enrolment" v-if="enrolments.length > 0" v-for="enrolment in enrolments">
                <router-link v-if="canView(enrolment)" :to="{
                        name: 'admin.relations.trajectory-enrolments.view',
                        params: {
                            'relationId': enrolment.candidate_id,
                            'trajectoryEnrolmentId': enrolment.id,
                        }
                    }"
                >
                    <h5 style="color: black;">{{ $getIfExists(enrolment, 'trajectory_name') }}</h5>
                </router-link>
                <h5 v-else style="color: black;">{{ $getIfExists(enrolment, 'trajectory_name') }}</h5>

                <span class="enrolment-info" :title="uLang('app.candidate')">
                    <i class="fa fa-lg fa-user"></i>
                    <link-if-permissions
                        v-if="canView(enrolment)"
                        :to="{ name: 'admin.relations.view', params: { id: enrolment.candidate_id }}"
                        permissions="view-relations"
                    >
                        <span class="text-brand">
                            {{ getCandidateName(enrolment) }}
                        </span>
                    </link-if-permissions>
                    <span v-else>{{ getCandidateName(enrolment) }}</span>
                </span>
            </div>
            <div class="col-12" v-if="!enrolments || enrolments.length === 0">
                {{ uLang('app.no_enrolments') }}
            </div>
        </div>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'CoachResultCandidatesModal',
        props: {
            value: Boolean,
            enrolments: {
                type: Array,
                default: [],
            },
        },
        computed: {
            ...mapGetters([`authId`, 'authAdmin']),
        },
        methods: {
            getCandidateName(enrolment) {
                const first_letters = $getIfExists(enrolment, 'candidate_first_letters')
                const first_name = $getIfExists(enrolment, 'candidate_first_name')
                const prefix = $getIfExists(enrolment, 'candidate_prefix')
                const last_name = $getIfExists(enrolment, 'candidate_last_name')

                return `${ (first_name || first_letters || '') } ${ (prefix || '') } ${ last_name }`
            },
            canView(enrolment) {
                return (this.authAdmin || $hasRole('super_admin')) || enrolment.coach_id === this.authId
            },
        },
    };
</script>

<style>
    .relative {
        position: relative;
    }

    .modal-body {
        min-height: 100px;
        position: relative;
    }

    .row .enrolment:not(:last-child) {
        margin-bottom: 30px;
    }
    .enrolment-info {
        display: block;
    }
</style>
